export const PCD_FORM_MODES = Object.freeze({
  CREATE: "create",
  EDIT: "edit"
});

export const SNIPPET_API_ENDPOINTS = Object.freeze({
  PCD_BASE: "admin/global-contests/pcd-snippets"
});

export const NOTIFICATION_MESSAGES = Object.freeze({
  PCD_CREATE_SUCCESS: "PCD snippet created successfully!",
  PCD_UPDATE_SUCCESS: "PCD snippet updated successfully!",
  PCD_DELETE_SUCCESS: "PCD snippet deleted successfully!",
  URL_COPY_SUCCESS: "Public URL copied to clipboard!",
  URL_COPY_FAILURE: "Failed to copy URL"
});

export const PCD_SNIPPET_LABELS = Object.freeze({
  TABLE_TITLE: "PCD Snippets Management",
  SEARCH_PLACEHOLDER: "Search by problem name or contest link...",
  ADD_BUTTON: "Add PCD Snippet"
});

export const PCD_SNIPPET_COLUMN_TITLES = Object.freeze({
  PROBLEM_NAME: "Problem Name",
  CONTEST_LINK: "Contest Link",
  PLATFORM: "Platform",
  LANGUAGES: "Languages",
  CREATED_BY: "Created By",
  CREATED_AT: "Created At",
  UPDATED_AT: "Updated At",
  ACTIONS: "Actions"
});

export const PCD_SNIPPET_MODAL_TEXT = Object.freeze({
  AT_LEAST_ONE_SNIPPET_ERROR: "At least one code snippet is required",
  CREATE_TITLE: "Add PCD Snippet",
  EDIT_TITLE: "Edit PCD Snippet"
});

/**
 * Supported coding languages for PCD snippets.
 * Must mirror backend CODING_LANGUAGE_ENUM.
 */
export const PCD_LANGUAGE_ENUM = Object.freeze({
  CPP: "C++",
  JAVA: "Java",
  PYTHON: "Python"
});

/**
 * Language display config for the code snippet tabs.
 * Order determines tab order; C++ is first (mandatory).
 */
export const PCD_LANGUAGE_CONFIG = [
  { key: PCD_LANGUAGE_ENUM.CPP, label: "C++", isMandatory: false },
  { key: PCD_LANGUAGE_ENUM.JAVA, label: "Java", isMandatory: false },
  { key: PCD_LANGUAGE_ENUM.PYTHON, label: "Python", isMandatory: false }
];

/**
 * Builds the public PCD snippet URL for a given slug.
 * @param {string} slug - PCD snippet slug
 * @returns {string} Public URL
 */
export const buildPublicPcdUrl = (slug) => {
  const baseUrl = "https://www.tle-eliminators.com";
  return `${baseUrl}/snippets/${slug}`;
};

export const PCD_PAGINATION_CONFIG = Object.freeze({
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: ["10", "20", "50"]
});
